import React, { useContext } from "react";

import { HandlerContext } from "components/lnb/LnbWrapper";

import imgThumbnail2 from "styles/common/img/common/more.png";

function SubBoxWrapper({ children, info, titleText, menuTypeCode, disableIcon, customClassName, drawCd = null }) {
    const handlerContext = useContext(HandlerContext);

    const handleClickTitle = () => {
        console.log(menuTypeCode);
        if (menuTypeCode === "POP") {
            handlerContext.clickMenuTypeCodePOP(info, drawCd);
        } else if (menuTypeCode === "POP_F") {
            handlerContext.clickMenuTypeCodePOPF(info, drawCd);
        } else if (menuTypeCode === "LINK") {
            handlerContext.clickMenuTypeCodeLINK(info, drawCd);
        } else if (menuTypeCode === "APP") {
            handlerContext.clickMenuTypeCodeAPP(drawCd);
        } else if (menuTypeCode === "EXT_LINK") {
            handlerContext.clickMenuTypeCodeEXT_LINK(info, drawCd);
        }
    };

    return (
        <div className={customClassName}>
            <div className="clear infortxtbox1" onClick={handleClickTitle}>
                <h2 className="leftTitle fl">{titleText}</h2>
                {!disableIcon && (
                    <button className="leftIcon fr">
                        <img src={imgThumbnail2} alt="더보기" />
                    </button>
                )}
            </div>
            {children}
        </div>
    );
}

export default SubBoxWrapper;
